// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from "./ienvironment";

// The list of file replacements can be found in `angular.json`.
export const environment: IEnvironment = {
  name: "development",
  clientCode: "demo",
  clientName: "Zoesen LLC",
  appFullName: "Zoesen Project Management System",
  appName: "Zoesen Project Management System",
  clientUrl: "https://www.zoesen.com/",
  clientLogo: "./assets/zoesen_white.png",
  version: "4.4.3.20240915",
  production: false,
  clientId: "pps_management_system",
  clientRoot: "https://demo.zoesencloud.com/",
  stsAuthority: "https://demo.auth.zoesencloud.com",
  apiRoot: "https://demo.api.zoesencloud.com"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
